import { RootState } from "@redux/store/store";
import { ModuleConstant } from "@shared-web/helpers/moduleConstant";
import { useSelector } from "react-redux";

interface ModuleType {
  moduleId: number;
  moduleName: string;
  controlName: string;
}
const useModuleVariables = () => {
  const modules = useSelector((state: RootState) => state.auth.user.roleModules);

  return {
    Dashboard: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Dashboard),
    Repository: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Repository),
    ProjectListing: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Project_Listing),
    ProjectInitiation: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Project_Initiation),
    IPD: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.IPD),
    InitiationApproval: modules?.some(
      (module: ModuleType) => module.controlName === ModuleConstant.Initiation_Approval,
    ),
    CogsEstimation: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Cogs_Estimation),
    Commercials: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Commercials),
    InHouseSelection: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.In_House_Selection),
    FormulationBudgetForm: modules?.some(
      (module: ModuleType) => module.controlName === ModuleConstant.Formulation_Budget_Form,
    ),
    APIDevelopmentForm: modules?.some(
      (module: ModuleType) => module.controlName === ModuleConstant.API_Development_Form,
    ),
    APICommercials: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.API_Commercials),
    InLicensedProject: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.In_Licensed_Project),
    FinalSchedule: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Final_Schedule),
    RevenueGCRollUp: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Revenue_GC_RollUp),
    FinalPLEvaluataion: modules?.some(
      (module: ModuleType) => module.controlName === ModuleConstant.Final_PL_Evaluataion,
    ),
    Reports: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Reports),
    Admin: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Admin),
    UserManagement: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.UserManagement),
    MasterManagement: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.MasterManagement),
    DateFormat: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.DateFormat),
    GroupCurrency: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.GroupCurrency),
    FinalApproval: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.FinalApproval),
    Level1Approval: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Level1Approval),
    Level2Approval: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Level2Approval),
    GroupUom: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.GroupUom),

    //Formulation Development sub-modules
    FormulationDevelopment: modules?.some(
      (module: ModuleType) => module.controlName === ModuleConstant.Formulation_Development,
    ),
    API: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.API),
    ExcipientsPM: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Excipients_PM),
    Analytical: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Analytical),
    BERLDCost: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.BE_RLD_Cost),
    ToolingPlantCost: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Tooling_Plant_Cost),
    ManpowerCost: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Manpower_Cost),
    FilingCost: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Filing_Cost),
    //API Development sub-modules
    APIDevelopment: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.API_Development),
    APIRequirement: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.API_Requirement),
    OtherMaterials: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Other_Materials),
    AnalyticalAPI: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Analytical_API),
    ManpowerAPI: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Manpower_API),
    Tooling: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Tooling),
    PlantCost: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Plant_Cost),
    APIFilingCost: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.API_Filing_Cost),
    Documents: modules?.some((module: ModuleType) => module.controlName === ModuleConstant.Documents),
  };
};

export default useModuleVariables;
